const appNames = ['EpiPortal', 'EpiAnalyst', 'EpiConnect', 'EpiVault', 'EpiVirtualCare'];

export default appNames;
